import Vue from 'vue';
import VueWorker from 'vue-worker';
import router from '../router';
import { BASEURL, IMGUPLOAD } from '../fetch/host';
import { base64ToBlob, removeUserInfo, isIos } from '../utils/api';

import {
	ALIPAYURL,
	ARTICLEURL,
	CHARACTERURL,
	EVALUATEURL,
	EVENTURL,
	INSTITUTEURL,
	INVSGTURL,
	PLAYBACKURL,
	REQUEST_VERSION,
	REALNAMEURL,
	STATISTIC_NUMBER,
	STOCKURL,
	THIRDPARTY,
	TOPICURL
} from '../utils/const';

import {
	appGoPlayback,
	appGoRoom,
	appHideTip,
	appOpenUrl,
	dateFormat,
	getBrowser,
	getOpenid,
	getUserInfo,
	getVersionCompared,
	isAndroid,
	isOpenHarmony,
	isApp,
	isCjzq,
	isHtzq,
	isHuatzq,
	isWxMiniProgram,
	isZszq,
	isZyzq,
	jumpToAppStore,
	removeBr,
	saveUserInfo,
	getUrlParam,
	debounce,
	initWxMiniProgramPath,
	judgeIsComeinDomain
} from '../utils/api';

import NativeApp from '../utils/app';

// 长江证券合作引入文件
import '../assets/scripts/cj/jockey.js';

import bridge from '../thirdparty/scripts/bridge';
Vue.use(bridge);

Vue.use(VueWorker);
const vue = new Vue({
	router
});

let timer_tooltip = null;

/**
 *  处理登陆校验 201 错误
 *  */
export const handleError201 = ctx => {
	let isComeInMP = sessionStorage.getItem('isComeInMP');
	if (isWxMiniProgram && isComeInMP) {
		ctx.dispatch('showDialog', {
			dialog_alert: true,
			dialog_text: '您的登录信息过期,重新登录',
			dialog_alert_data: [
				{
					btn: '确定',
					callback: () => {
						wx.miniProgram.navigateTo({
							url: initWxMiniProgramPath(isComeInMP, vue.$route.fullPath)
						});
					}
				}
			]
		});
		return;
	}

	// 第三方合作不需要在进门做登录的、跳转到第三方的处理方法里面
	if (vue.$bridge.joinEventFail) {
		vue.$bridge.joinEventFail.call(vue, 201, ctx);
		return;
	}

	/* 兼容第三方 异地登录处理 */
	if (vue.$bridge.isThirdParty) {
		if (vue.$bridge.authMethod === 1) {
			ctx.dispatch('showDialog', {
				dialog_affirm: true,
				dialog_text: '请先登录账号',
				dialog_confirm_btn: () => {
					vue.$router.push({
						name: 'institute_login',
						query: {
							comein_channel: getUrlParam().comein_channel
						}
					});
				}
			});
		} else {
			ctx.dispatch('showDialog', {
				dialog_alert: true,
				dialog_text: '重新登录',
				dialog_alert_data: [
					{
						btn: '确定',
						callback: () => {
							if (isZszq) {
								ctx.dispatch('zsGetUDID', {
									code_201: true
								});
							} else {
								const sessionChannelSign = JSON.parse(sessionStorage.getItem(THIRDPARTY)) || {};

								ctx.dispatch('fetchWebChannelLogin', {
									channel: sessionChannelSign.comein_channel,
									info: sessionChannelSign.comein_sign,
									success: res => {
										saveUserInfo(res);
										vue.$router.go(0);
									}
								});
							}
						}
					}
				]
			});
		}
		return;
	}

	const userInfo = getUserInfo();
	// 判断本地是否有登录信息，如果有，认为异地登录,确定跳转登录页
	if (userInfo) {
		console.log('异地登录-移除用户信息');
		removeUserInfo();
		ctx.dispatch('showDialog', {
			dialog_alert: true,
			dialog_text: '该账号已在其他设备登录，为保证账号安全，请重新登录',
			dialog_alert_data: [
				{
					btn: '我知道了',
					callback: () => {
						if (window.location.href.includes('localhost')) {
							vue.$router.push({
								name: 'login',
								query: {
									successUrl: vue.$route.fullPath
								}
							});
						} else {
							window.location.href = `/mobile/login?successUrl=${encodeURIComponent(
								vue.$route.fullPath
							)}`;
						}
					}
				}
			]
		});
	} else {
		removeUserInfo();
		// 如果本地没有登录信息，指引登录
		ctx.dispatch('showDialog', {
			dialog_affirm: true,
			dialog_text: '请先登录进门账号',
			dialog_confirm_btn: () => {
				const { comein_channel } = vue.$route.query;
				if (comein_channel && comein_channel === 'brm') {
					return window.parent?.postMessage({ event: 'login_out' }, '*');
				}
				if (isWxMiniProgram && isComeInMP) {
					wx.miniProgram.navigateTo({
						url: initWxMiniProgramPath(isComeInMP, vue.$route.fullPath)
					});
				} else {
					if (window.location.href.includes('localhost')) {
						vue.$router.push({
							name: 'login',
							query: {
								successUrl: vue.$route.fullPath
							}
						});
					} else {
						window.location.href = `/mobile/login?successUrl=${encodeURIComponent(vue.$route.fullPath)}`;
					}
				}
			}
		});
	}
};

/** 数据统计 **/
// param： 请求参数；参考文档
// config:  (可选) xhr 配置；
export const statistic = (ctx, { param, config }) => {
	if (isApp) {
		const header = {
			app: 'json',
			mod: 'statistic',
			act: 'click',
			timestamp: Date.now()
		};
		param = Object.assign(header, param);

		NativeApp.sendRequest({
			id: window.$comein.genKey(),
			request: param
		});
	} else {
		// 非app内调用
		// 添加统一加字段
		// @b   版本号
		// @c   pc/mobile
		// @os  'web'
		// @s   浏览器信息（内核+版本）
		const header = {
			// os: isWxMiniProgram ? 'mp' : 'h5',
			os: 'web',
			c: 'h5',
			b: REQUEST_VERSION,
			ua: navigator.userAgent,
			s: getBrowser().kernel + '@' + getBrowser().version,

			// 第三方 带uc
			// uc: isZszq ? "zszq" : isCjzq ? 'cjzq' : isHtzq ? "htzq" : isHuatzq ? "huataizq" : isZyzq ? "zyzq" : isWx? 'weixin' : '',
			uc: vue.$bridge.uc
				? vue.$bridge.uc
				: isZszq
					? 'zszq'
					: isCjzq
						? 'cjzq'
						: isHtzq
							? 'htzq'
							: isHuatzq
								? 'huataizq'
								: isZyzq
									? 'zyzq'
									: '',
			app: 'json',
			mod: 'statistic',
			act: 'click',
			uid: !getUserInfo() ? null : getUserInfo().uid,
			timestamp: Date.now()
		};

		// 合并请求参数
		param = Object.assign(header, param);

		ctx.dispatch('worker', {
			param,
			config
		});
	}
};
// 新建线程并发送请求
export const worker = (ctx, { param, config }) => {
	// 获取平台
	const platform = (() => {
		if (isApp) {
			if (isIos) {
				return 'ios';
			} else if (isAndroid || isOpenHarmony) {
				return 'android';
			}
		} else {
			return 'web';
		}
	})();

	// 参数格式判断
	if (param) {
		if (Object.prototype.toString.call(param) !== '[object Object]') {
			throw new Error('参数param格式错误：' + param + '，期望格式为Object');
		}
	} else {
		param = {};
	}

	// 配置对象格式判断
	if (config) {
		if (Object.prototype.toString.call(config) !== '[object Object]') {
			throw new Error('参数config格式错误：' + config + '，期望格式为Object');
		}
	} else {
		config = {};
	}

	// 发起另一个线程
	try {
		vue.$worker
			.run(
				(url, platform, param, config) => {
					// 初始化 xhr，responseText
					let xhr = null;
					let responseText = null;

					// 实例化 XMLHttpRequest
					if (XMLHttpRequest) {
						xhr = new XMLHttpRequest();
					} else if (ActiveXObject) {
						xhr = new ActiveXObject('Microsoft.XMLHTTP');
					}

					// 接收请求状态变化
					xhr.onreadystatechange = function () {
						switch (xhr.readyState) {
							case 0:
								// 状态为：UNSENT
								// 说明：代理被创建，但尚未调用 open() 方法
								console.log('新线程请求创建成功');
								break;
							case 1:
								// 状态为：OPENED
								// 说明：open() 方法已经被调用
								console.log('新线程请求开始发起');
								break;
							case 2:
								// 状态为：HEADERS_RECEIVED
								// 说明：send() 方法已经被调用，并且头部和状态已经可获得
								console.log('新线程请求正在送往服务器');
								break;
							case 3:
								// 状态为：LOADING
								// 说明：下载中，responseText 属性已经包含部分数据
								console.log('新线程服务器已经在收集数据了');
								break;
							case 4:
								console.log('新线程服务器完成了所有动作！');
								if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
									responseText = JSON.parse(xhr.responseText);
								} else {
									console.log('Request was unsuccessful : ' + xhr.status + ' ' + xhr.statusText);
								}
								break;
							default:
								console.log('不开心，服务器出错啦！');
						}
					};

					// xhr 选项配置
					const option = {
						isAsync: false,
						url: config.url || url,
						method: config.method || 'POST'
					};

					// 请求参数-头部固定参数
					const data = {
						os: platform
					};

					// 合并头部和自定义参数
					if (param)
						for (let v in param) {
							if (param.hasOwnProperty(v)) data[v] = param[v];
						}

					// 发起xhr请求
					if (option.method.toLowerCase() === 'post') {
						xhr.open(option.method, option.url, option.isAsync);
						xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8');
						xhr.send(postDataFormat(data));
					} else if (option.method.toLowerCase() === 'get') {
						xhr.open(option.method, option.url + '?' + postDataFormat(data), option.isAsync);
						xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
						xhr.send();
					}

					// 格式化post 传递的数据
					function postDataFormat(obj) {
						let arr = [];
						for (let attr in obj) {
							if (obj.hasOwnProperty(attr)) arr.push(attr + '=' + obj[attr]);
						}
						return arr.join('&');
					}

					// 输出 responseText
					return responseText;
				},
				[BASEURL, platform, param, config]
			)
			.then(result => {
				if (result.errorcode === '0') {
					if (config.success) {
						const success = new Function('return ' + config.success)();
						success(result.data, result.extra);
					}

					// 打印统计成功提示语
					if (param.mod === 'statistic') {
						console.log(
							'本次统计了: {pagetype: ' +
							param.pagetype +
							',typeid: ' +
							param.typeid +
							',pagearea：' +
							param.pagearea +
							'}'
						);
					}
				} else {
					if (config.error) {
						const error = new Function('return ' + config.error)();
						error(result.errorcode, result.errordesc, result.extra);
					}
				}
			})
			.catch(e => {
				console.error(e);
			});
	} catch (err) {
		console.log('新线程创建失败');
		console.log(err);
	}
};

// 校验图片地址合法性
export const validateImage = (ctx, pathImg) => {
	return new Promise((resolve, reject) => {
		console.log('validateImage', pathImg);
		var ImgObj = new Image(); //判断图片地址是否有效
		ImgObj.src = pathImg;
		ImgObj.onload = res => {
			resolve(res);
		};
		ImgObj.onerror = err => {
			console.log(err);
			reject(err);
		};
	});
};

// 检查用户状态是否异常
export const checkUserAuthStatus = function (ctx, { callbackFun, isRequire = false }) {
	return new Promise((resolve, reject) => {
		ctx.dispatch('fetchUserWarnAuth', {
			success: res => {
				console.log(res);
				if (res.auth) {
					ctx.dispatch('showAuthDialog', {
						auth_dialog: true,
						// 安全验证
						auth_dialog_type: 'userwarn',
						auth_dialog_content: res.phoneNumber ? res.areaCode + ' ' + res.phoneNumber : res.email,
						auth_dialog_close__btn: () => { },
						auth_dialog_success__btn: callbackFun,
						auth_dialog_require: isRequire
					});
				} else {
					typeof callbackFun == 'function' && callbackFun.call();
				}
			},
			error: code => { }
		});
	});
};

// 用于避免小程序多次跳转
let liveRoomLock = false;

/** 跳转路演直播间  eid、meta(app)
 * ** @replace ： 是否替换当前页面 （ undefined : 不替换； 1： 替换）
 * **/
export const jumpToLiveRoom = debounce(function (ctx, obj) {
	let isComeInMP = sessionStorage.getItem('isComeInMP');

	checkUserAuthStatus(ctx, {
		callbackFun: () => {
			if (isApp) {
				appGoRoom(obj.eid, obj.meta && obj.meta);
			} else if (isWxMiniProgram && isComeInMP) {
				if (liveRoomLock) {
					return;
				} else {
					liveRoomLock = true;
					setTimeout(() => {
						liveRoomLock = false;
					}, 1000);

					let url =
						isComeInMP == 2
							? '/package_live/pages/live/index?eid=' + obj.eid
							: '/livePackage/live/live?eid=' + obj.eid;

					wx.miniProgram.navigateTo({
						url
					});
				}
			} else {
				if (obj.replace) {
					vue.$router.replace({
						name: 'roadshow_room',
						query: {
							id: obj.eid,
							comein_channel: getUrlParam().comein_channel
						}
					});

					// window.location.replace(EVENTURL + obj.eid + (getUrlParam().comein_channel ? '&comein_channel=' + getUrlParam().comein_channel : "") + '#live');
				} else {
					vue.$router.push({
						name: 'roadshow_room',
						query: {
							id: obj.eid,
							comein_channel: getUrlParam().comein_channel
						}
					});
					// location.href = EVENTURL + obj.eid + (getUrlParam().comein_channel ? '&comein_channel=' + getUrlParam().comein_channel : "") + '#live';
				}
			}
		}
	})
		.then(() => {
			return;
		})
		.catch(() => {
			return;
		});
	// return;
});

/** 跳转路演 （路演详情和回放）
 *
 * 新增路演公开状态：openStatus
 * 0：私密；1：公开；2：专场；3：私募；4：课程；5：开户分仓；6：实名认证；7：申请参会；8：投资调研；9：专栏路演
 * obj : {}
 * @id(必填) : 路演/回放 id
 * @openStatus(必填)：路演公开状态
 * @ct(选填) ：contenttype (0/undefined: 路演；1：回放)
 * @inner(选填)：APP内部跳转 是否采用 内部跳转的方式（vue-router）
 * @replace(选填) ： 是否替换当前页面
 * @optional(选填) ：额外增加的路由参数
 * **/

/**
 * 	公开状态openstatus
 *  0: 私密
 *	1: 公开
 *	2: 专场（包含机构和专场活动）
 *	3: 私募
 *	4: 课程
 *	5: 开户分仓
 *	6: 实名认证
 *	7: 申请参会
 *	8: 投资调研
 *	9: 专栏路演
 *	10: 付费路演
 *	12: 会员
 * @param { Object } ctx
 * @param { Object } obj
 * @property { String } obj.id 路演id
 * @property { Object } obj.optional 额外参数
 * @property { String } obj.openStatus 路演状态
 * @property { Number } obj.ct 0/undefined: 路演；1：回放
 * @property { Boolean } obj.replace 是否替换当前页面
 * @property {} obj.checkUserAsset
 * @property {} obj.inner APP内部跳转 是否采用 内部跳转的方式
 *
 */
export const jumpToRoadshow = (ctx, obj) => {
	// 声明 search 保存 路由 额外参数
	let search = '';
	if (obj.optional) {
		for (let key in obj.optional) {
			if (obj.optional[key] === undefined || obj.optional[key] === null || obj.optional[key] === '') {
				continue;
			}

			search += `&${key}=${obj.optional[key]}`;
		}
	}
	let query = {
		id: obj.id,
		comein_channel: getUrlParam().comein_channel
	};

	Object.assign(query, obj.optional);

	// 区别App和H5跳转
	// 路演
	if (!Number(obj.ct) || obj.ct === undefined) {
		const UILoaded = 82218;
		const UIScrolled = 2;
		const UIGlobal = 106;

		Object.assign(query, {
			UILoaded,
			UIScrolled,
			UIGlobal
		});

		if (isApp) {
			// 兼容旧版本 路演 跳转
			ctx.dispatch('getAppClientInfo', res => {
				if (getVersionCompared(res.data.version, '3.4.0') < 0) {
					appGoRoom(obj.id, null);
				} else {
					let jump_url =
						location.origin +
						'/mobile/roadshow/home' +
						'?UILoaded=' +
						UILoaded +
						'&UIScrolled=' +
						UIScrolled +
						'&UIGlobal=' +
						UIGlobal +
						'&id=' +
						obj.id +
						search;

					// 采用vue-router内部跳转方式
					if (Number(obj.inner)) {
						vue.$router.replace({
							name: 'roadshow_home',
							query
						});
					} else {
						if (Number(obj.replace)) {
							location.replace(jump_url);
						} else {
							appOpenUrl({ url: jump_url });
						}
					}
				}
			});
		} else {
			obj.replace
				? vue.$router.replace({
					name: 'roadshow_home',
					query
				})
				: vue.$router.push({
					name: 'roadshow_home',
					query
				});
		}
	} else {
		const UILoaded = 378;
		const UIGlobal = 106;
		const UIScrolled = 378;

		Object.assign(query, {
			UILoaded,
			UIScrolled,
			UIGlobal
		});

		if (isApp) {
			// 兼容旧版本 回放 跳转
			ctx.dispatch('getAppClientInfo', res => {
				if (getVersionCompared(res.data.version, '3.4.0') < 0) {
					appGoPlayback(obj.id);
				} else {
					let jump_url =
						location.origin +
						'/mobile/roadshow/record' +
						'?UILoaded=' +
						UILoaded +
						'&UIGlobal=' +
						UIGlobal +
						'&UIScrolled=' +
						UIScrolled +
						'&id=' +
						obj.id +
						search;
					// 采用vue-router内部跳转方式
					if (Number(obj.inner)) {
						vue.$router.replace({
							name: 'roadshow_record',
							query
						});
					} else {
						if (Number(obj.replace)) {
							location.replace(jump_url);
						} else {
							appOpenUrl({ url: jump_url });
						}
					}
				}
			});
		} else {
			obj.replace
				? vue.$router.replace({
					name: 'roadshow_record',
					query
				})
				: vue.$router.push({
					name: 'roadshow_record',
					query
				});
		}
	}
};

/** 显示提示条 **/
// 增加：time值为0时，不隐藏
// time值为undefined（不给）时，默认 2000ms
// @param { Object } obj(msg, time)
export const showTooltip = (ctx, obj) => {
	let config = {
		msg: '',
		icon: '',
		img: '',
		className: '',
		time: 2000
	};
	if (typeof obj === 'string') {
		config.msg = obj;
	} else {
		Object.assign(config, obj);
	}

	ctx.commit('showTooltip', config);

	if (config.time > 0) {
		timer_tooltip = setTimeout(() => {
			ctx.commit('hideTooltip');
			clearTimeout(timer_tooltip);
		}, config.time);
	}
};

export const hideTooltip = ctx => {
	clearTimeout(timer_tooltip);
	ctx.commit('hideTooltip');
};

/** 显示对话框中 **/
// @obj { Object } obj 参考关于dialog定义的state变量
export const showDialog = (ctx, obj) => {
	console.log(ctx, obj.dialog_text);
	ctx.commit('setDialog', obj);
	ctx.commit('setDialogCancelBtn', () => {
		ctx.dispatch('hideDialog', obj.dialog_cancel_btn);
	});
	ctx.commit('setDialogConfirmBtn', () => {
		ctx.dispatch('hideDialog', obj.dialog_confirm_btn);
	});
};

export const hideDialog = (ctx, cb) => {
	ctx.commit('setDialog', {
		dialog_alert: false,
		dialog_affirm: false,
		dialog_title: '',
		dialog_text: '',
		dialog_cancel_text: '取消',
		dialog_confirm_text: '确认',
		dialog_cancel_btn: new Function(),
		dialog_confirm_btn: new Function(),
		dialog_alert_data: [{ btn: '确定', callback: new Function() }]
	});
	typeof cb === 'function' && cb();
};

// 验证码弹窗
export const showAuthDialog = (ctx, obj) => {
	ctx.commit('setAuthDialog', obj);
};

export const hideAuthDialog = (ctx, obj) => {
	ctx.commit('setAuthDialog', {
		auth_dialog: false
	});
};

/** 更新APP版本 **/
export const updateApp = (ctx, v) => {
	if (isApp && (isAndroid || isOpenHarmony)) {
		// 安卓APP（需要根据版本号决定如何跳转,3.3.0之后可以内部跳转）
		// 兼容 没有传v的情况
		// 安卓APP（需要根据版本号决定如何跳转,3.3.0之后可以内部跳转）
		// 兼容 没有传v的情况
		let userInfo = getUserInfo();
		ctx.dispatch('androidUpdateApp', v || userInfo.version);
	} else {
		jumpToAppStore();
	}
};

/** 安卓下载的核心逻辑 **/
export const androidUpdateApp = (ctx, v) => {
	if (v < '3.3.1') {
		ctx.dispatch('showTooltip', {
			msg: '请前往应用商店下载'
		});
	} else {
		NativeApp.downloadApp();
	}
};

/** 拨打电话 **/
export const callUp = (ctx, num) => {
	num = num.replace(/\s*/g, '');
	if (isApp) {
		NativeApp.callUp({
			phoneNumber: num
		}).catch(() => {
			ctx.dispatch('showTooltip', {
				msg: '拨打号码失败',
				time: 500
			});
		});
	} else {
		location.href = 'tel:' + num;
	}
};

/** 加载中 **/
export const showLoading = ctx => {
	ctx.commit('showLoading');
};

export const hideLoading = ctx => {
	ctx.commit('hideLoading');
};

/**同意协议弹框**/
export const showAgreementBox = ctx => {
	ctx.commit('showAgreementBox');
};

export const hideAgreementBox = ctx => {
	ctx.commit('hideAgreementBox');
};

/** app 获取客户端信息 **/
export const getAppClientInfo = (ctx, cb) => {
	if (ctx.state.appClientInfo) {
		cb && cb(ctx.state.appClientInfo);
	} else {
		NativeApp.getClientInfo().then(res => {
			if (!Number(res.code)) {
				console.log(11, res);
				ctx.commit('setAppClientInfo', res);
				cb && cb(res);
			}
		});
	}
};

/** app 退出 webNative(新的方法，建议使用这个) **/
export const goExitWebNative = ctx => {
	NativeApp.goExit();
};

/**
 * app跳转分享
 * @param title {String} 分享标题
 * @param types {String} 分享类型
 * 		// Group 1: 1.短信分享(只解析shareContent) 2.微信好友 3.微信朋友圈 4.新浪微博 5.进门好友 6.qq好友 7.qq空间 14.企业微信
 *      // Group 2: 8.二维码 9.复制链接 10.投诉 11.邀请卡(邀请有奖) 20.邀请赚钱(路演) 21.邀请卡 22.邀请榜 23.意见反馈 30.复制邀请 31.分享口令
 * @param content {String} 分享内容
 * @param url {String} 分享的跳转url地址
 * @param extraDataMap {Object} 额外参数
 * 			10： sourceTypeld ： 源类型ID(moduleld=2必填):0=无，1=路演会议 2=IR旗舰店，3=调研活动，4=券商研究，5=专栏，6=分师榜单，7=课程，8=市场观察，9=分析师详情，10=专题，11=用户详情
 */
export const appShare = shareData => {
	NativeApp.goShare({
		types: shareData.types,
		shareTitle: shareData.title || '',
		shareContent: shareData.sharecontent || '',
		shareUrl: shareData.shareurl || '',
		shareImageUrl: shareData.logo || '',
		extra: shareData.extra || '',
		callback: shareData.callback || '',
		shareStatistic: shareData.shareStatistic || '',
		minId: shareData.minId || '',
		minPath: shareData.minPath || '',
		extraDataMap: {},
		success: () => {
			typeof shareData.success === 'function' && shareData.success();
		}
	});
};

/** wx share **/
/**
 * title;
 * desc;
 * link;
 * img_url;
 * */
export const wxShare = (ctx, shareData) => {
	console.log('wxShare', shareData);

	/* wx小程序 传递分享内容 */
	if (isWxMiniProgram) {
		wx.miniProgram.postMessage({
			data: {
				name: vue.$route.name,
				fullPath: shareData.min_link || vue.$route.fullPath,
				shareTitle: shareData.title,
				shareImg: shareData.min_img_url || shareData.img_url,
				shareStatistic: shareData.shareStatistic
			}
		});
	}

	// 特殊处理 分享时带pagesource=shareshare
	let shareLink = shareData.link;
	const regPageSource = /(\?|&)pagesource=[A-Za-z0-9]+/;
	const regPageSourceId = /(\?|&)pagesourceid=[A-Za-z0-9]+/;
	shareLink = shareLink.replace(regPageSource, '').replace(regPageSourceId, '');
	shareLink = shareLink + (shareLink.indexOf('?') > -1 ? '&' : '?') + 'pagesource=share';

	// 微信绑定分享
	const wxShareFun = shareData => {
		shareData.desc = removeBr(shareData.desc);
		wx.ready(() => {
			wx.onMenuShareTimeline({
				title: shareData.title,
				link: shareLink,
				imgUrl: shareData.img_url,
				success: () => {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			wx.onMenuShareAppMessage({
				title: shareData.title,
				desc: shareData.desc,
				link: shareLink,
				imgUrl: shareData.img_url,
				success: () => {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			wx.onMenuShareQQ({
				title: shareData.title,
				desc: shareData.desc,
				link: shareLink,
				imgUrl: shareData.img_url,
				success: () => {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			wx.onMenuShareQZone({
				title: shareData.title,
				desc: shareData.desc,
				link: shareLink,
				imgUrl: shareData.img_url,
				success: () => {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			wx.onMenuShareWeibo({
				title: shareData.title,
				desc: shareData.desc,
				link: shareLink,
				imgUrl: shareData.img_url,
				success: () => {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			// 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
			wx.updateAppMessageShareData({
				title: shareData.title, // 分享标题
				desc: shareData.desc, // 分享描述
				link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: shareData.img_url, // 分享图标
				success: function () {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
			// 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
			wx.updateTimelineShareData({
				title: shareData.title, // 分享标题
				link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl: shareData.img_url, // 分享图标
				success: function () {
					typeof shareData.success === 'function' && shareData.success();
				}
			});
		});
	};
	try {
		wxShareFun(shareData);
	} catch (e) {
		console.log('无法绑定微信');
	}
};

// TODO 这里滚动到底部，safari上有兼容问题
/**页面滚动到底部
 *
 * @param cb {Function} 页面滚动到底部执行的回调
 */
export const scrollToBottom = (ctx, cb) => {
	$(window).off('scroll');
	let isBottom = true;
	$(window).bind('scroll', function () {
		const scrollTop = Math.ceil($(this).scrollTop());
		const windowHeight = $(this).height();
		const documentHeight = $(document).height();

		// console.log($(this).scrollTop())
		// console.log(scrollTop)
		// console.log(windowHeight)
		// console.log(documentHeight)
		// scrollTop可能小数部分有偏差
		// 滚动到底部判断
		if (scrollTop > 0 && scrollTop + windowHeight >= documentHeight) {
			if (isBottom) {
				isBottom = false;
				setTimeout(() => {
					isBottom = true;
				}, 1000);
				cb && cb();
			}
		}
	});
};

export const redirect_iframe = (ctx, { src, ...params }) => {
	function showDialog() {
		return ctx.dispatch('showDialog', {
			dialog_alert: true,
			dialog_text: '该文件地址失效，暂不支持打开',
			dialog_alert_data: [
				{
					btn: '知道了',
					callback: () => {
						ctx.dispatch('hideDialog');
					}
				}
			]
		});
	}

	if (!src || typeof src !== 'string' || src.indexOf('.comein.cn') === -1) {
		return showDialog();
	}

	let index = src.lastIndexOf('.');
	if (index <= 0 || index === src.length - 1) {
		return showDialog();
	}

	let fileType = src.slice(index + 1).toLowerCase();

	if (isWxMiniProgram && (fileType === 'doc' || fileType === 'docx')) {
		return wx.miniProgram.navigateTo({
			url: vue.$bridge.downloadFile + src
		});
	}

	vue.$bridge.navigateTo.call(vue, {
		name: 'iframe',
		query: {
			src,
			comein_channel: vue.$bridge.comein_channel,
			...params
		}
	});
};

export const setSignBase64 = (ctx, base64) => {
	return new Promise((resolve, reject) => {
		if (!base64) {
			ctx.signBase64 = '';
			resolve();
		} else {
			const blob = base64ToBlob(base64);
			const formData = new FormData();
			formData.append('image', blob);
			formData.append('type', '2');
			$.ajax({
				url: IMGUPLOAD,
				type: 'POST',
				data: formData,
				processData: false,
				contentType: false,
				success: res => {
					if (res.errorcode === '0') {
						ctx.commit('setSignBase64', res.data[0].imageurl);
						resolve(res.data[0].imageurl);
					} else {
						reject(res);
					}
				},
				error: e => {
					reject(e);
				}
			});
		}
	});
};

/**
 * 上传文件，如图片
 * @param store {String} store实例
 * @param options {Object} 上传文件所需的对象属性{ type, file}
 * @param success {Function} 上传文件成功的回调函数
 * @returns
 */
export const ossFileUploadNew = (store, { options }) => {
	return new Promise((resolve, reject) => {
		store.dispatch('fetchOssSignature', {
			fileType: options.type,
			success: res => {
				const data = res;
				const name = options.file.name.split('.').pop();
				let formData = new FormData();
				const body = {
					key: data.dir + '.' + name,
					policy: data.policy,
					OSSAccessKeyId: data.accessid,
					callback: data.callback,
					signature: data.signature,
					file: options.file
				};
				Object.keys(body).map(index => {
					formData.append(index, body[index]);
				});
				const targetHost = data.acceleratehost || data.host;
				$.ajax({
					url: targetHost,
					type: 'POST',
					dataType: 'JSON',
					cache: false,
					data: formData,
					processData: false,
					contentType: false,
					success: res => {
						resolve(res);
					},
					error: function (err) {
						reject(err);
					}
				});
			},
			error: (code, desc) => {
				reject({ code, desc });
			}
		});
	});
};

/**
 * 名片识别
 * @param store {String} store实例
 * @param options {Object} 上传文件所需的对象属性{ type, file}
 * @param success {Function} 上传文件成功的回调函数
 * @returns
 */
export const identifyBusinessCard = (store, { options }) => {
	return new Promise((resolve, reject) => {
		store
			.dispatch('ossFileUploadNew', {
				options: options
			})
			.then(res1 => {
				store.dispatch('fetchBusinessCard', {
					viewUrl: res1.viewurl + '?fileType=img',
					success: res2 => {
						resolve(res2);
					},
					error: (code, desc) => {
						reject({ code, desc });
					}
				});
			})
			.catch((code, desc) => {
				reject({ code, desc });
			});
	});
};
